var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-auth"},[_c('google-signin-btn',{staticClass:"sign-in-button",attrs:{"label":"Sign In"},on:{"click":_vm.googleSignIn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }